export default __webpack_public_path__ + "static/media/KZ.T.05.0594.60e39cbf.svg";